import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _map from 'lodash/map';
import _trim from 'lodash/trim';
import _values from 'lodash/values';
import _forEach from 'lodash/forEach';
import _size from 'lodash/size';
import { EMPTY_OBJECT, EMPTY_ARRAY, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import UserReader from '@tekion/tekion-base/readers/User';
import NoteItem from './NoteItem';
import NoteEditor from './NoteEditor';
import PropertyControlledComponent from '../PropertyControlledComponent';
import Button from '../../atoms/Button';
import NoteReader from './Note.reader';
import { VIEW_TYPE } from './constants/note.general';
var Note = /*#__PURE__*/function (_React$Component) {
  _inherits(Note, _React$Component);
  var _super = _createSuper(Note);
  function Note() {
    var _this;
    _classCallCheck(this, Note);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isExpanded: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleExpandButton", function () {
      _this.setState(function (_ref) {
        var isExpanded = _ref.isExpanded;
        return {
          isExpanded: !isExpanded
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleAddNote", function (note, taggedUsers) {
      var _this$props = _this.props,
        assetId = _this$props.assetId,
        handleAddNewNote = _this$props.handleAddNewNote,
        tags = _this$props.tags;
      if (_trim(note) === '') {
        return;
      }
      handleAddNewNote(assetId, note, tags, taggedUsers);
    });
    // check if the current user has previously added any note
    _defineProperty(_assertThisInitialized(_this), "hasCurrentUserNote", function () {
      var notes = _this.props.notes;
      var currentUserId = NoteReader.getCurrentUserId(_this.props);
      var hasNotes = false;
      _forEach(notes, function (note) {
        if (currentUserId !== note.userId) return true;
        hasNotes = true;
        return false;
      });
      return hasNotes;
    });
    _defineProperty(_assertThisInitialized(_this), "canAddNote", function () {
      var canUserAddMultipleNotes = _this.props.canUserAddMultipleNotes;
      if (canUserAddMultipleNotes) return true;
      return !_this.hasCurrentUserNote();
    });
    _defineProperty(_assertThisInitialized(_this), "renderNote", function (note) {
      var _this$props2 = _this.props,
        assetId = _this$props2.assetId,
        handleUpdateNote = _this$props2.handleUpdateNote,
        handleDeleteNote = _this$props2.handleDeleteNote,
        singleComment = _this$props2.singleComment,
        view = _this$props2.view,
        disableActionButtons = _this$props2.disableActionButtons,
        disabled = _this$props2.disabled,
        validators = _this$props2.validators,
        showPinnedNote = _this$props2.showPinnedNote,
        handlePinAction = _this$props2.handlePinAction,
        canDeleteAnyNote = _this$props2.canDeleteAnyNote,
        canDeleteSelfAddedNote = _this$props2.canDeleteSelfAddedNote,
        enableMentions = _this$props2.enableMentions,
        personas = _this$props2.personas;
      var currentUser = {
        id: NoteReader.getCurrentUserId(_this.props),
        image: NoteReader.getCurrentUserImage(_this.props)
      };
      return /*#__PURE__*/React.createElement(NoteItem, {
        key: NoteReader.getNoteId(note),
        view: view,
        assetId: assetId,
        noteItem: note,
        currentUser: currentUser,
        handleUpdateNote: handleUpdateNote,
        handleDeleteNote: handleDeleteNote,
        singleComment: singleComment,
        disableActionButtons: disableActionButtons || disabled,
        validators: validators,
        handlePinAction: handlePinAction,
        showPinnedNote: showPinnedNote,
        canDeleteAnyNote: canDeleteAnyNote,
        canDeleteSelfAddedNote: canDeleteSelfAddedNote,
        enableMentions: enableMentions,
        personas: personas
      });
    });
    return _this;
  }
  _createClass(Note, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        assetId = _this$props3.assetId,
        notes = _this$props3.notes,
        singleComment = _this$props3.singleComment,
        view = _this$props3.view,
        disabled = _this$props3.disabled,
        validators = _this$props3.validators,
        getSortedNotes = _this$props3.getSortedNotes,
        currentUser = _this$props3.currentUser,
        listCollapsible = _this$props3.listCollapsible,
        noteEditorClassName = _this$props3.noteEditorClassName,
        autoFocusEditor = _this$props3.autoFocusEditor,
        shouldScrollIntoView = _this$props3.shouldScrollIntoView,
        enableMentions = _this$props3.enableMentions,
        personas = _this$props3.personas;
      var isExpanded = this.state.isExpanded;
      var currentUserName = UserReader.name(currentUser);
      var currentUserImage = UserReader.profileImgUrl(currentUser);
      var notesLength = _size(notes);
      return /*#__PURE__*/React.createElement(Fragment, null, disabled || singleComment && notesLength ? null : /*#__PURE__*/React.createElement(NoteEditor, {
        key: NoteReader.getNoteLength(notes),
        view: view,
        isEditing: this.canAddNote(),
        assetId: assetId,
        image: currentUserImage,
        userName: currentUserName,
        handleAddOrUpdate: this.handleAddNote,
        showAddBtn: !disabled,
        validators: validators,
        className: noteEditorClassName,
        autoFocus: autoFocusEditor,
        shouldScrollIntoView: shouldScrollIntoView,
        enableMentions: enableMentions,
        personas: personas
      }), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: !listCollapsible || isExpanded
      }, _map(getSortedNotes(notes), this.renderNote)), /*#__PURE__*/React.createElement(PropertyControlledComponent, {
        controllerProperty: listCollapsible && notesLength
      }, /*#__PURE__*/React.createElement(Button, {
        view: Button.VIEW.TERTIARY,
        onClick: this.handleExpandButton,
        highlightOnHover: false
      }, isExpanded ? __('Hide') : __('Show Previous Notes ({{ notesLength }})', {
        notesLength: notesLength
      }))));
    }
  }]);
  return Note;
}(React.Component);
_defineProperty(Note, "propTypes", {
  view: PropTypes.oneOf(_values(VIEW_TYPE)),
  assetId: PropTypes.string,
  notes: PropTypes.array,
  handleAddNewNote: PropTypes.func,
  handleUpdateNote: PropTypes.func,
  handleDeleteNote: PropTypes.func,
  canUserAddMultipleNotes: PropTypes.bool,
  singleComment: PropTypes.bool,
  disableActionButtons: PropTypes.bool,
  disabled: PropTypes.bool,
  validators: PropTypes.array,
  showPinnedNote: PropTypes.bool,
  handlePinAction: PropTypes.func,
  getSortedNotes: PropTypes.func,
  canDeleteAnyNote: PropTypes.bool,
  currentUser: PropTypes.object,
  noteEditorClassName: PropTypes.string,
  tags: PropTypes.array,
  canDeleteSelfAddedNote: PropTypes.bool,
  listCollapsible: PropTypes.bool,
  autoFocusEditor: PropTypes.bool,
  enableMentions: PropTypes.bool,
  personas: PropTypes.array
});
_defineProperty(Note, "defaultProps", {
  view: VIEW_TYPE.DEFAULT,
  assetId: EMPTY_STRING,
  notes: EMPTY_ARRAY,
  handleAddNewNote: _noop,
  handleUpdateNote: _noop,
  handleDeleteNote: _noop,
  canUserAddMultipleNotes: true,
  singleComment: false,
  disableActionButtons: false,
  disabled: false,
  validators: EMPTY_ARRAY,
  showPinnedNote: false,
  handlePinAction: _noop,
  getSortedNotes: NoteReader.getNotesOrderedByCreatedTime,
  canDeleteAnyNote: false,
  currentUser: EMPTY_OBJECT,
  noteEditorClassName: '',
  tags: null,
  canDeleteSelfAddedNote: true,
  listCollapsible: false,
  autoFocusEditor: true,
  enableMentions: false,
  personas: EMPTY_ARRAY
});
export default Note;